import { createSelector } from 'reselect';
import Gates from '../constants/Gates';
export const getGates = state => state.auth.gates;
export const getIsUngatedForDevelopersUnifiedAppsPrivateBeta = createSelector([getGates], gates => {
  var _gates$includes;
  return (_gates$includes = gates === null || gates === void 0 ? void 0 : gates.includes(Gates.DEVELOPERS_UNIFIED_APPS_PRIVATE_BETA)) !== null && _gates$includes !== void 0 ? _gates$includes : false;
});